// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editor3{
    padding: 10px;
    width: 400px;
    height: 300px;
    background-color: #ccc;
    border: 1px solid #000;
    flex-shrink: 0;
    letter-spacing: 1px;
}

.editor3 p::before{
    content: "-";
    display: inline-block;
    width: 0px;
    opacity: 0;
}

.editor3 ul{
    padding-left: 16px;
}

.break{
    display: block;
}

.current-li{
    background-color: #9fc;
}

.current-p{
    background-color: rgb(233, 235, 156);
}

.b{
    padding: 3px;
    border: 1px solid;
}`, "",{"version":3,"sources":["webpack://./src/pages/desktopPage/editor3.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,qBAAqB;IACrB,UAAU;IACV,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB","sourcesContent":[".editor3{\n    padding: 10px;\n    width: 400px;\n    height: 300px;\n    background-color: #ccc;\n    border: 1px solid #000;\n    flex-shrink: 0;\n    letter-spacing: 1px;\n}\n\n.editor3 p::before{\n    content: \"-\";\n    display: inline-block;\n    width: 0px;\n    opacity: 0;\n}\n\n.editor3 ul{\n    padding-left: 16px;\n}\n\n.break{\n    display: block;\n}\n\n.current-li{\n    background-color: #9fc;\n}\n\n.current-p{\n    background-color: rgb(233, 235, 156);\n}\n\n.b{\n    padding: 3px;\n    border: 1px solid;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
